import React from 'react';
import { Star } from 'lucide-react';
import { Section } from './Shared';
export interface TestimonialProps {
  initials: string;
  name: string;
  location: string;
  text: string;
  product?: string;
}
export const TestimonialCard = ({
  initials,
  name,
  location,
  text,
  product
}: TestimonialProps) => <div className="glass-panel p-6 md:p-8 rounded-2xl flex flex-col h-full border-brand-purple/15" data-id="element-273" data-mp="3b1chl3y5wofz">
    <div className="flex items-center mb-4" data-id="element-274" data-mp="36z94kavuhbsl">
      <div className="w-9 h-9 md:w-12 md:h-12 rounded-full bg-brand-surfaceLight flex items-center justify-center text-brand-purple font-serif font-bold text-sm md:text-xl border border-brand-purple/30 mr-3 md:mr-4 shrink-0 shadow-sm" data-id="element-275" data-mp="36wwgdfzhu573">
        {initials}
      </div>
      <div data-id="element-276" data-mp="2s308tjb5xgkx">
        <div className="flex text-brand-gold mb-1 text-[15px] md:text-lg" data-id="element-277" data-mp="2s39skp5m6ri6">
          {[...Array(5)].map((_, i) => <Star key={i} className="w-4 h-4 fill-current" data-id="element-278" data-mp="v8nbxaplulim" data-mpi={i} />)}
        </div>
        <div className="font-medium text-brand-text md:text-lg" data-id="element-279" data-mp="qbeqn195u1d5">{name}</div>
        <div className="text-xs md:text-sm text-brand-muted" data-id="element-280" data-mp="h5ezpnh15z1q">
          {location} {product && `— ${product}`}
        </div>
      </div>
    </div>
    <p className="text-brand-text/90 italic flex-grow text-[13px] md:text-base font-serif leading-relaxed" data-id="element-281" data-mp="m6cgbvme6l14">
      "{text}"
    </p>
  </div>;
export const InitialTestimonials = () => {
  return <Section className="pt-8 pb-16" data-id="element-282" data-mp="c7dhf4rfi3rb">
      <div className="max-w-3xl mx-auto" data-id="element-283" data-mp="zwfxi86ezojp">
        <TestimonialCard initials="MG" name="María G." location="Córdoba" text="Por primera vez tengo un sistema completo para planificar mis sesiones de Chi Kung con criterio clínico real. Mis pacientes sienten la diferencia desde la primera semana." data-id="element-284" data-mp="zxhawjawkn4l" />
      </div>
    </Section>;
};
export const MoreTestimonials = () => {
  const testimonials = [{
    initials: 'MG',
    name: 'María G.',
    location: 'Córdoba',
    product: 'Terapeuta holística',
    text: 'Por primera vez tengo un sistema para planificar mis sesiones con criterio clínico real. El Vademécum de series por patología me cambió completamente la forma de trabajar.'
  }, {
    initials: 'JL',
    name: 'Julián L.',
    location: 'Buenos Aires',
    product: 'Chi Kung terapéutico',
    text: 'El Tomo I de blindaje del terapeuta me salvó del agotamiento crónico. Antes terminaba cada jornada destruida. Ahora tengo protocolos reales y mi energía es completamente diferente.'
  }, {
    initials: 'SM',
    name: 'Sofía M.',
    location: 'Rosario',
    product: 'Terapeuta en formación',
    text: 'Recién empezaba y el Mega Pack me dio la estructura que necesitaba desde el primer paciente. Los 52 guiones de visualización solos valen todo el pack.'
  }, {
    initials: 'DL',
    name: 'Diego L.',
    location: 'Tucumán',
    product: 'Terapeuta holístico',
    text: 'El Protocolo de Chi Kung Adaptado me abrió un nicho que no imaginaba. Ahora trabajo con adultos mayores y pacientes post-quirúrgicos con total seguridad clínica.'
  }];
  return <Section className="pt-8 pb-16" data-id="element-285" data-mp="qu2gj5hrqex6">
      <div className="text-center mb-12" data-id="element-286" data-mp="32gw78o5mksgn">
        <h2 className="md:text-4xl font-display font-bold uppercase tracking-[0.12em] mb-4 text-[22px] text-brand-burgundy" data-id="element-287" data-mp="32fukhmf8yhj3">
          Lo que dicen los terapeutas
        </h2>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6 text-[12px] md:text-sm max-w-4xl mx-auto" data-id="element-288" data-mp="3cetsr3w3ob5k">
        {testimonials.map((t, i) => <TestimonialCard key={i} {...t} data-id="element-289" data-mp="3gg5cwtw7g46d" data-mpi={i} />)}
      </div>
    </Section>;
};